<script>
import api from '@/helpers/api'
import Multiselect from 'vue-multiselect'
export default {
  name: 'supplier-select',
  props: { value: { type: String } },
  components: { Multiselect },
  data: vm => ({
    suppliers: [],
    selected: null
  }),
  methods: {
    async init () {
      let { items } = await api.suppliers.fetchPage({
        page: 1,
        pageSize: -1
      })

      this.suppliers = [...items]
      this.selected = this.suppliers.find(c => c.id === this.value)
    },
    onSelected (supplier) {
      this.$emit('input', supplier ? supplier.id : null)
      this.$emit('select', supplier)
    }
  },
  mounted () {
    this.init()
  },
  watch: {
    value: {
      handler: 'init',
      immediate: true
    }
  },
  computed: {
    listeners () {
      return { ...this.$listeners, select: 'onSelected' }
    }
  }
}
</script>
<template>
  <Multiselect
    :options="suppliers"
    :custom-label="({ id, legal_name }) => `${legal_name}`"
    track-by="id"
    v-model="selected"
    :placeholder="$attrs.placeholder || 'Select a Supplier'"
    v-bind="$attrs"
    @input="onSelected"
    v-on:close="$emit('blur')"
  ></Multiselect>
</template>

<style lang="scss">
.multiselect__content-wrapper {
  overflow-x: hidden;
}
</style>
